/**
 * Persistent banner shown across the entire admin SPA when the current
 * session is an impersonation (SuperAdmin → "Open as them"). Operator
 * can't miss it, every page, every state. Click "Exit" to log out
 * cleanly and return to the login screen.
 *
 * Token TTL is 1h server-side, but the banner has its own "Exit" so
 * the operator can leave whenever instead of waiting it out (a
 * lingering paid-action click as the wrong identity is precisely what
 * we're avoiding).
 */
import { useAuth } from '../contexts/AuthContext';
import './ImpersonationBanner.css';

export default function ImpersonationBanner() {
  const { impersonating, impersonatedBy, clubName, logout } = useAuth();
  if (!impersonating) return null;

  return (
    <div className="impersonation-banner" role="alert">
      <span className="ib-icon" aria-hidden>🛠</span>
      <span className="ib-text">
        Viewing as <strong>{clubName || 'this club'}</strong>
        {impersonatedBy && <> · operator: <code>{impersonatedBy}</code></>}
        <span className="ib-sub"> · 1-hour session, audit-logged</span>
      </span>
      <button
        type="button"
        className="ib-exit"
        onClick={() => {
          logout();
          window.location.href = '/';
        }}
        title="Sign out of this impersonation"
      >
        Exit →
      </button>
    </div>
  );
}
